import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "page" }
const _hoisted_2 = {
  class: "o-container js-main-container u-bg-white",
  style: {"position":"relative"}
}
const _hoisted_3 = { class: "u-bg-white o-container__remove u-pad-y-2" }
const _hoisted_4 = { class: "o-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GevHeader = _resolveComponent("GevHeader")!
  const _component_GevFooter = _resolveComponent("GevFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_GevHeader, { produkt: "Fehler" }),
    _createElementVNode("main", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[9] || (_cache[9] = _createElementVNode("h2", { class: "u-mar-t-0 u-mar-b-3 u-text-align-center" }, "Fehler", -1)),
          _createElementVNode("p", null, [
            _cache[0] || (_cache[0] = _createTextVNode(" Sehr geehrte Besucherin, sehr geehrter Besucher,")),
            _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
            _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.fehlermeldung) + " ", 1),
            _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
            _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
            _cache[5] || (_cache[5] = _createTextVNode(" Unser Online-Team sucht bereits nach einer Lösung. ")),
            _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
            _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
            _cache[8] || (_cache[8] = _createTextVNode(" Ihre GEV "))
          ])
        ])
      ])
    ]),
    _createVNode(_component_GevFooter)
  ]))
}